export default __webpack_public_path__ + "static/media/show-clothes-2.b5fd859e.webp";